<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  props: {
    chartPropData: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    currentJobName: '',
    datasets: [],
    lineChartOptions: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: true,
            },
          },
        ],
      },
      legend: {
        display: true,
      },
      responsive: true,
      maintainAspectRatio: false,
    },
    labels: [],
    matrixDataSet: [],
    currentDataSet: [],
    colorSet: {
      0: '#2897ce',
      1: '#fc833d',
      2: '#148214',
      3: '#f05a00',
      4: '#f02800',
    },
  }),
  methods: {
    initChart() {
      // Reset chart data
      this.matrixDataSet = [];
      this.currentJobName = '';

      // const isString = (val) => typeof val === 'string';

      /* for (const [key, value] of Object.entries(this.chartPropData)) {
        this.labels = [];
        this.currentDataSet = [];

        for (const [innerKey, innerValue] of Object.entries(value)) {
          if (isString(innerValue)) {
            this.currentJobName = innerValue;
          } else {
            this.labels.push(innerValue.day);
          }

          this.currentDataSet.push(innerValue.count);
        }

        this.matrixDataSet.push(this.currentDataSet);

        this.datasets.push({
          label: this.currentJobName,
          data: this.matrixDataSet[key],
          backgroundColor: 'transparent',
          borderColor: this.colorSet[key],
          pointBackgroundColor: this.colorSet[key],
        });
      } */

      for (const [key, value] of Object.entries(this.chartPropData)) {
        this.labels = [];
        this.currentDataSet = [];

        for (const [innerKey, innerValue] of Object.entries(value)) {
          this.labels.push(innerValue.day);
          this.currentJobName = `${innerValue.job_name}, ${innerValue.city_name}`;
          this.currentDataSet.push(innerValue.count);
        }

        this.matrixDataSet.push(this.currentDataSet);

        this.datasets.push({
          label: this.currentJobName,
          data: this.matrixDataSet[key],
          backgroundColor: 'transparent',
          borderColor: this.colorSet[key],
          pointBackgroundColor: this.colorSet[key],
        });
      }

      this.renderChart(
        {
          labels: this.labels,
          datasets: this.datasets,
        },
        this.lineChartOptions,
      );
    },
  },
  computed: {
    isDataLoaded() {
      const loadedData = this.chartPropData.length !== 0;
      return loadedData;
    },
  },
  mounted() {
    this.initChart();
    /* [
          {
            label: this.chartData.jobName,
            data: dataSet1,
            backgroundColor: 'transparent',
            borderColor: '#2897ce',
            pointBackgroundColor: '#2897ce',
          },
          {
            label: jobName,
            data: dataSet1,
            backgroundColor: 'transparent',
            borderColor: '#2897ce',
            pointBackgroundColor: '#2897ce',
          },
          {
            label: 'React developer',
            data: dataSet2,
            backgroundColor: 'transparent',
            borderColor: '#fc833d',
            pointBackgroundColor: '#fc833d',
          },
          {
            label: 'Business Analyst',
            data: dataSet3,
            backgroundColor: 'transparent',
            borderColor: '#6ebe6e',
            pointBackgroundColor: '#6ebe6e',
          },
        ] */
  },
};
</script>

<style lang="scss" scoped>
.sss {
  color: rgb(146, 146, 146);
}
</style>